import FarmBalanceTable from "@/features/logistics/components/FarmBalanceTable"
import SPLFarmHeader from "@/features/logistics/components/SPLFarmHeader"

export default function FarmBalances() {
  return (
    <>
      <SPLFarmHeader />
      <FarmBalanceTable />
    </>
  )
}
